'use strict';

/**
 * Created by shadd01 on 4/13/16.
 */
module.exports = {
    removeSpecialCharacters: function removeSpecialCharacters(value) {
        if (typeof value === 'string') {
            return value.replace(/[^a-zA-Z0-9\s\+]/g, "");
        }
        return '';
    },
    formatCardNumber: function formatCardNumber(value, charsPerSection) {
        var parts = [];
        for (var i = 0; i < value.length; i += charsPerSection) {
            parts.push(value.substring(i, i + charsPerSection));
        }
        if (parts.length) {
            value = parts.join(' ');
        }

        return value;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/StringHelper.js
// module id = 208
// module chunks = 0